import { motion } from "framer-motion";

export const EASE = [0.25, 0.1, 0.25, 1];

export function Reveal({ children, delay = 0, className = "" }) {
  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, y: 12 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-40px" }}
      transition={{ duration: 0.5, delay: Math.min(delay, 0.15), ease: EASE }}
    >
      {children}
    </motion.div>
  );
}

export function Kicker({ children, className = "" }) {
  return (
    <p className={`text-xs font-semibold uppercase tracking-[0.2em] text-gold-dark ${className}`}>
      {children}
    </p>
  );
}
